import { ImageWithTextSection } from '@quicktools/shared-components';
import IImageWithTextSection from '@quicktools/shared-components/components/landingPages/ImageWithTextSection/types';
import { Trans, useTranslation } from 'react-i18next';

function ImageSections() {
  const { t } = useTranslation();

  const texts = t('landing.imageSection', { returnObjects: true }) as IImageWithTextSection[];

  let imageSectionItems: IImageWithTextSection[] = [
    {
      imageWidth: 435,
      imgSrc: 'images/image-section-1.png',
      imgAlt: 'changeIt',
    },
    {
      imageWidth: 381,
      imgSrc: 'images/image-section-2.png',
      imgAlt: 'changeIt',
      imageRight: true,
    },
  ];

  imageSectionItems = imageSectionItems.map((section, i) => ({
    ...section,
    ...texts[i],
    description: (
      <Trans i18nKey={`landing.imageSection.${i}.description`} components={{ a: <a /> }} />
    ),
  }));

  return (
    <>
      {imageSectionItems.map(({ ...sectionProps }, i) => (
        <ImageWithTextSection key={i} {...sectionProps} />
      ))}
    </>
  );
}

export default ImageSections;
